import React from "react";
import { RequestStatus } from "../../helpers";

const RequestLink = ({ requestNumber, formPartType }) => {
  const url =
    formPartType.toUpperCase() === "REGULATORY"
      ? `/protocol-setup/regulatory/${requestNumber}`
      : `/protocol-setup/open-rave/${requestNumber}`;


  return requestNumber && requestNumber !== "null" ? (
    <a href={url} title={`View Request ${requestNumber}`}>
      Request {requestNumber}
    </a>
  ) : (
    "Request"
  );
};
const hasValidStatusRequestNumber = (statusRequestNumber) =>
  statusRequestNumber !== null &&
  statusRequestNumber !== undefined &&
  String(statusRequestNumber).toLowerCase() !== "null" &&
  String(statusRequestNumber).trim() !== "";

const ExistingRequestChangeMessage = ({
  formPartType,
  lpo,
  protocolNumber,
  requestStatus,
  requestNumber,
  statusArr
}) => {
  const statusRequestNumber = statusArr?.[1];

  const nextRequestNumber = hasValidStatusRequestNumber(statusRequestNumber)
    ? statusRequestNumber
    : requestNumber;
  const status = statusArr?.[2] || requestStatus;
  const displayType = formPartType === "OPEN_RAVE" ? "Open Rave" : "Regulatory";

  const visibleStatus = ["NEW", "DRAFT"].includes(requestStatus) ? requestStatus : status;
  const visibleRequestNumber  = ["NEW", "DRAFT"].includes(requestStatus) ? requestNumber : nextRequestNumber;
  return (
    <div>
      <p>
        There is already an existing &quot;
        <strong>{`${displayType} | ${lpo} | ${protocolNumber}`}</strong>
        &quot; request change in {RequestStatus[visibleStatus]}-status. Please make any changes in the existing{" "}
        <RequestLink
          requestNumber={visibleRequestNumber}
          formPartType={formPartType}
        />
        .
      </p>
    </div>
  );
};

export default ExistingRequestChangeMessage;
